var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "over_layout" }, [
    _c("section", { staticClass: "upgrade" }, [
      _c(
        "a",
        {
          staticStyle: { cursor: "pointer" },
          on: {
            click: function($event) {
              return _vm.$store.commit("paymentModal", true)
            }
          }
        },
        [_vm._v(_vm._s(_vm.$store.getters.t("create_resume")))]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "contact_page" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "pages_header" }, [
          _c("div", { staticClass: "lines" }, [
            _c("h1", [_vm._v(_vm._s(_vm.$store.getters.t("contacts")))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _c(
              "p",
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.translations[_vm.$store.getters.locale]["start"]
                    ) +
                    "\n                        "
                ),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "faq",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.translations[_vm.$store.getters.locale]["link"]
                      )
                    )
                  ]
                ),
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.translations[_vm.$store.getters.locale]["end"]) +
                    "\n                    "
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contact_block clearfix" }, [
          _c("div", { staticClass: "contact_left_block" }, [
            _c("div", { staticClass: "all_title_block left_block" }, [
              _c("div", { staticClass: "title_block" }, [
                _c("div"),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$store.getters.t("write_us")))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "block" }, [
              _c("ul", [
                _c("li", {
                  staticClass: "c_info_1",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$store.getters
                        .t("crweb_address")
                        .replace("<br><br>", "")
                    )
                  }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form_block" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.sendComment($event)
                    }
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:3",
                        expression: "'required|min:3'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.name,
                        expression: "name"
                      }
                    ],
                    staticClass: "inp_type",
                    class: _vm.errors.first("name") ? "invalid" : "",
                    attrs: {
                      placeholder: _vm.$store.getters.t("name"),
                      name: "name",
                      type: "text",
                      required: ""
                    },
                    domProps: { value: _vm.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.name = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    staticClass: "inp_type",
                    class: _vm.errors.first("email") ? "invalid" : "",
                    attrs: {
                      name: "email",
                      placeholder: _vm.$store.getters.t("email"),
                      type: "email",
                      required: ""
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.comment,
                        expression: "comment"
                      }
                    ],
                    class: _vm.errors.first("comment") ? "invalid" : "",
                    attrs: {
                      placeholder: _vm.$store.getters.t("description"),
                      name: "comment",
                      required: ""
                    },
                    domProps: { value: _vm.comment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.comment = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "inp_send",
                    attrs: { type: "submit" },
                    domProps: { value: _vm.$store.getters.t("send") }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact_right_block" }, [
            _c("div", { staticClass: "block_soc" }, [
              _c("div", { staticClass: "name_block" }, [
                _vm._v(
                  _vm._s(
                    _vm.translations[_vm.$store.getters.locale]["in_social"]
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "soc" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$store.getters.t("facebook_foot_link"),
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/vue/images/soc_icon_1.png" }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: "/vue/images/soc_icon_hover_1.png" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$store.getters.t("instagram_foot_link"),
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/vue/images/instagram_icon.png" }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: "/vue/images/instagram_icon-hover.png" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(3)
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "block_fb" })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "c_info_2" }, [
      _c("a", { attrs: { href: "tel:+37498587373" } }, [
        _vm._v("+374 98 58 73 73")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "c_info_3" }, [
      _c("a", { attrs: { href: "mailto:support@cvweb.ru" } }, [
        _vm._v("support@cvweb.ru")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "maps" } }, [
      _c("iframe", {
        staticStyle: { border: "0" },
        attrs: {
          src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1524.1832888015851!2d44.51831650060976!3d40.17865471670326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abdacebb0f85b%3A0x78958a772a1511ed!2sCreative+Web+Yerevan!5e0!3m2!1sru!2s!4v1548944537256",
          width: "100%",
          height: "100%",
          frameborder: "0",
          allowfullscreen: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.linkedin.com/company/cvweb-ru",
          target: "_blank"
        }
      },
      [
        _c("img", { attrs: { src: "/vue/images/soc_icon_3.png" } }),
        _vm._v(" "),
        _c("img", { attrs: { src: "/vue/images/soc_icon_hover_3.png" } })
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16000269", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16000269","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Contacts.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-16000269","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Contacts.vue
// module chunks = 0